import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

type AppLoaderProps = {
  label?: string;
  className?: string;
  tone?: "dark" | "light";
};

export function AppLoader({ label = "Laden", className, tone = "dark" }: AppLoaderProps) {
  const isLight = tone === "light";

  return (
    <div
      className={cn(
        "flex min-h-[50vh] w-full items-center justify-center",
        isLight ? "bg-white text-zinc-950" : "bg-background text-foreground",
        className
      )}
      aria-busy="true"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 rounded-full border border-current/10 bg-current/[0.03] px-4 py-2 shadow-sm backdrop-blur-sm">
        <Loader2 className="h-4 w-4 animate-spin text-primary" aria-hidden="true" />
        <span className="text-xs font-semibold uppercase tracking-[0.18em] opacity-70">{label}</span>
      </div>
    </div>
  );
}
